import { NgTemplateOutlet } from '@angular/common';
import { Component, inject, TemplateRef } from '@angular/core';
import { NgbToastModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { ToastService } from 'src/app/service/toast.service';
import { TranslationService } from 'src/app/service/translation.service';

@Component({
    selector: 'app-toast-component',
    templateUrl: './toast.component.html',
    styleUrls: ['./toast.component.scss'],
    imports: [TranslateModule, NgbToastModule, NgTemplateOutlet],
    providers: [TranslationService],
    standalone: true
})
export class ToastComponent {

  toastService = inject(ToastService);
  private readonly translationService = inject(TranslationService);

  constructor() {
   
  }

	isTemplate(toast:any) {
		return toast.textOrTpl instanceof TemplateRef;
	}

}
